// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_Lp","refLinkDesktop":"e_Mp","titleFont":"e_Np"};